import type { CardHooks } from "./registry";

/**
 * Reversal — Signature Move (Utility).
 *
 * Legality:
 *   Requires 2 resolved counters this round (consecutiveCounters tracker on
 *   PlayerState, incremented in resolveCounterEffects, reset on aggressor
 *   flip / round start).
 *
 * Effect (on play / utility resolution):
 *   Negates the opponent's attack currently sitting in the combat slot.
 *   Unlike normal Negate, this does NOT refund the attacker's stamina,
 *   untap their weapon, or roll back their sig-in-play marker — they
 *   keep what they spent. Priority goes back to the attacker at
 *   aggressor-pre-attack so they may act again.
 *
 *   The engine field `negateInPlaySlot` (handled in applyResults) does all
 *   the slot-removal, attacksThisRound decrement, priority shift, and
 *   consecutiveCounters reset. Keeping the hook tiny mirrors Pocket Sand's
 *   declarative style.
 */
export const reversal: CardHooks = {
  canPlayUtility: (ctx) => {
    if ((ctx.self.consecutiveCounters ?? 0) < 2) {
      return {
        enabled: false,
        reason: "Requires 2 resolved counters this round.",
      };
    }
    return { enabled: true };
  },
  onUtilityPlay: (_ctx) => {
    return {
      negateInPlaySlot: true,
      log: [
        "Reversal — attack negated in the combat slot; no stamina refunded.",
      ],
    };
  },
};